"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.inputMixin = exports.getPadding = exports.getCssSize = exports.extractTopBottomBoxShadow = exports.boxShadowOf = exports.boxShadow = exports.border = exports.BoxShadowElement = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
require("core-js/modules/es6.regexp.split.js");
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.string.starts-with.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _polished = require("polished");
var _styledComponents = require("styled-components");
var _themeMapper = require("@gravity/theme-mapper");
var _lodash = require("lodash");
var _templateObject, _templateObject2;
function cov_2b1lomczov() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/evolutionUtils.js";
  var hash = "a1192052bb2f470c248dc4689b66833860f8c406";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/evolutionUtils.js",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 32
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "1": {
        start: {
          line: 17,
          column: 31
        },
        end: {
          line: 17,
          column: 35
        }
      },
      "2": {
        start: {
          line: 18,
          column: 30
        },
        end: {
          line: 18,
          column: 33
        }
      },
      "3": {
        start: {
          line: 19,
          column: 35
        },
        end: {
          line: 19,
          column: 39
        }
      },
      "4": {
        start: {
          line: 20,
          column: 33
        },
        end: {
          line: 20,
          column: 42
        }
      },
      "5": {
        start: {
          line: 21,
          column: 33
        },
        end: {
          line: 21,
          column: 50
        }
      },
      "6": {
        start: {
          line: 22,
          column: 28
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "7": {
        start: {
          line: 27,
          column: 30
        },
        end: {
          line: 31,
          column: 1
        }
      },
      "8": {
        start: {
          line: 54,
          column: 25
        },
        end: {
          line: 60,
          column: 1
        }
      },
      "9": {
        start: {
          line: 58,
          column: 5
        },
        end: {
          line: 60,
          column: 1
        }
      },
      "10": {
        start: {
          line: 81,
          column: 26
        },
        end: {
          line: 89,
          column: 1
        }
      },
      "11": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 84,
          column: 3
        }
      },
      "12": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 24
        }
      },
      "13": {
        start: {
          line: 85,
          column: 2
        },
        end: {
          line: 87,
          column: 3
        }
      },
      "14": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 17
        }
      },
      "15": {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 88,
          column: 14
        }
      },
      "16": {
        start: {
          line: 123,
          column: 26
        },
        end: {
          line: 153,
          column: 1
        }
      },
      "17": {
        start: {
          line: 124,
          column: 21
        },
        end: {
          line: 124,
          column: 44
        }
      },
      "18": {
        start: {
          line: 127,
          column: 15
        },
        end: {
          line: 127,
          column: 36
        }
      },
      "19": {
        start: {
          line: 130,
          column: 2
        },
        end: {
          line: 145,
          column: 3
        }
      },
      "20": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 132,
          column: 60
        }
      },
      "21": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 133,
          column: 12
        }
      },
      "22": {
        start: {
          line: 135,
          column: 6
        },
        end: {
          line: 135,
          column: 60
        }
      },
      "23": {
        start: {
          line: 136,
          column: 6
        },
        end: {
          line: 136,
          column: 12
        }
      },
      "24": {
        start: {
          line: 138,
          column: 6
        },
        end: {
          line: 138,
          column: 60
        }
      },
      "25": {
        start: {
          line: 139,
          column: 6
        },
        end: {
          line: 139,
          column: 12
        }
      },
      "26": {
        start: {
          line: 142,
          column: 6
        },
        end: {
          line: 142,
          column: 12
        }
      },
      "27": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 70
        }
      },
      "28": {
        start: {
          line: 147,
          column: 2
        },
        end: {
          line: 152,
          column: 4
        }
      },
      "29": {
        start: {
          line: 182,
          column: 27
        },
        end: {
          line: 194,
          column: 1
        }
      },
      "30": {
        start: {
          line: 182,
          column: 63
        },
        end: {
          line: 194,
          column: 1
        }
      },
      "31": {
        start: {
          line: 183,
          column: 16
        },
        end: {
          line: 183,
          column: 84
        }
      },
      "32": {
        start: {
          line: 184,
          column: 25
        },
        end: {
          line: 184,
          column: 55
        }
      },
      "33": {
        start: {
          line: 186,
          column: 2
        },
        end: {
          line: 188,
          column: 3
        }
      },
      "34": {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 187,
          column: 24
        }
      },
      "35": {
        start: {
          line: 190,
          column: 23
        },
        end: {
          line: 190,
          column: 73
        }
      },
      "36": {
        start: {
          line: 191,
          column: 2
        },
        end: {
          line: 193,
          column: 5
        }
      },
      "37": {
        start: {
          line: 217,
          column: 22
        },
        end: {
          line: 219,
          column: 1
        }
      },
      "38": {
        start: {
          line: 217,
          column: 42
        },
        end: {
          line: 219,
          column: 1
        }
      },
      "39": {
        start: {
          line: 217,
          column: 51
        },
        end: {
          line: 219,
          column: 1
        }
      },
      "40": {
        start: {
          line: 237,
          column: 41
        },
        end: {
          line: 253,
          column: 1
        }
      },
      "41": {
        start: {
          line: 239,
          column: 18
        },
        end: {
          line: 239,
          column: 44
        }
      },
      "42": {
        start: {
          line: 242,
          column: 27
        },
        end: {
          line: 249,
          column: 4
        }
      },
      "43": {
        start: {
          line: 243,
          column: 18
        },
        end: {
          line: 243,
          column: 44
        }
      },
      "44": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 247,
          column: 5
        }
      },
      "45": {
        start: {
          line: 245,
          column: 22
        },
        end: {
          line: 245,
          column: 30
        }
      },
      "46": {
        start: {
          line: 246,
          column: 6
        },
        end: {
          line: 246,
          column: 56
        }
      },
      "47": {
        start: {
          line: 248,
          column: 4
        },
        end: {
          line: 248,
          column: 17
        }
      },
      "48": {
        start: {
          line: 252,
          column: 2
        },
        end: {
          line: 252,
          column: 37
        }
      },
      "49": {
        start: {
          line: 255,
          column: 26
        },
        end: {
          line: 270,
          column: 1
        }
      },
      "50": {
        start: {
          line: 257,
          column: 6
        },
        end: {
          line: 270,
          column: 1
        }
      },
      "51": {
        start: {
          line: 262,
          column: 31
        },
        end: {
          line: 262,
          column: 76
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 54,
            column: 25
          },
          end: {
            line: 54,
            column: 26
          }
        },
        loc: {
          start: {
            line: 58,
            column: 5
          },
          end: {
            line: 60,
            column: 1
          }
        },
        line: 58
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 81,
            column: 26
          },
          end: {
            line: 81,
            column: 27
          }
        },
        loc: {
          start: {
            line: 81,
            column: 35
          },
          end: {
            line: 89,
            column: 1
          }
        },
        line: 81
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 123,
            column: 26
          },
          end: {
            line: 123,
            column: 27
          }
        },
        loc: {
          start: {
            line: 123,
            column: 61
          },
          end: {
            line: 153,
            column: 1
          }
        },
        line: 123
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 182,
            column: 27
          },
          end: {
            line: 182,
            column: 28
          }
        },
        loc: {
          start: {
            line: 182,
            column: 63
          },
          end: {
            line: 194,
            column: 1
          }
        },
        line: 182
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 182,
            column: 63
          },
          end: {
            line: 182,
            column: 64
          }
        },
        loc: {
          start: {
            line: 182,
            column: 72
          },
          end: {
            line: 194,
            column: 1
          }
        },
        line: 182
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 217,
            column: 22
          },
          end: {
            line: 217,
            column: 23
          }
        },
        loc: {
          start: {
            line: 217,
            column: 42
          },
          end: {
            line: 219,
            column: 1
          }
        },
        line: 217
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 217,
            column: 42
          },
          end: {
            line: 217,
            column: 43
          }
        },
        loc: {
          start: {
            line: 217,
            column: 51
          },
          end: {
            line: 219,
            column: 1
          }
        },
        line: 217
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 237,
            column: 41
          },
          end: {
            line: 237,
            column: 42
          }
        },
        loc: {
          start: {
            line: 237,
            column: 60
          },
          end: {
            line: 253,
            column: 1
          }
        },
        line: 237
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 242,
            column: 42
          },
          end: {
            line: 242,
            column: 43
          }
        },
        loc: {
          start: {
            line: 242,
            column: 52
          },
          end: {
            line: 249,
            column: 3
          }
        },
        line: 242
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 255,
            column: 26
          },
          end: {
            line: 255,
            column: 27
          }
        },
        loc: {
          start: {
            line: 257,
            column: 6
          },
          end: {
            line: 270,
            column: 1
          }
        },
        line: 257
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 262,
            column: 22
          },
          end: {
            line: 262,
            column: 23
          }
        },
        loc: {
          start: {
            line: 262,
            column: 31
          },
          end: {
            line: 262,
            column: 76
          }
        },
        line: 262
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 55,
            column: 10
          },
          end: {
            line: 55,
            column: 34
          }
        }],
        line: 55
      },
      "1": {
        loc: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 56,
            column: 10
          },
          end: {
            line: 56,
            column: 34
          }
        }],
        line: 56
      },
      "2": {
        loc: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 57,
            column: 52
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 57,
            column: 50
          },
          end: {
            line: 57,
            column: 52
          }
        }],
        line: 57
      },
      "3": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 45
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 57,
            column: 19
          },
          end: {
            line: 57,
            column: 45
          }
        }],
        line: 57
      },
      "4": {
        loc: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 82
      },
      "5": {
        loc: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 85
      },
      "6": {
        loc: {
          start: {
            line: 123,
            column: 36
          },
          end: {
            line: 123,
            column: 56
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 123,
            column: 51
          },
          end: {
            line: 123,
            column: 56
          }
        }],
        line: 123
      },
      "7": {
        loc: {
          start: {
            line: 124,
            column: 21
          },
          end: {
            line: 124,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 21
          },
          end: {
            line: 124,
            column: 28
          }
        }, {
          start: {
            line: 124,
            column: 32
          },
          end: {
            line: 124,
            column: 44
          }
        }],
        line: 124
      },
      "8": {
        loc: {
          start: {
            line: 130,
            column: 2
          },
          end: {
            line: 145,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 133,
            column: 12
          }
        }, {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 136,
            column: 12
          }
        }, {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 139,
            column: 12
          }
        }, {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 142,
            column: 12
          }
        }, {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 144,
            column: 70
          }
        }],
        line: 130
      },
      "9": {
        loc: {
          start: {
            line: 182,
            column: 37
          },
          end: {
            line: 182,
            column: 58
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 182,
            column: 56
          },
          end: {
            line: 182,
            column: 58
          }
        }],
        line: 182
      },
      "10": {
        loc: {
          start: {
            line: 183,
            column: 52
          },
          end: {
            line: 183,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 183,
            column: 67
          },
          end: {
            line: 183,
            column: 71
          }
        }, {
          start: {
            line: 183,
            column: 74
          },
          end: {
            line: 183,
            column: 83
          }
        }],
        line: 183
      },
      "11": {
        loc: {
          start: {
            line: 186,
            column: 2
          },
          end: {
            line: 188,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 186,
            column: 2
          },
          end: {
            line: 188,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 186
      },
      "12": {
        loc: {
          start: {
            line: 186,
            column: 6
          },
          end: {
            line: 186,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 186,
            column: 7
          },
          end: {
            line: 186,
            column: 13
          }
        }, {
          start: {
            line: 186,
            column: 17
          },
          end: {
            line: 186,
            column: 32
          }
        }, {
          start: {
            line: 186,
            column: 37
          },
          end: {
            line: 186,
            column: 49
          }
        }],
        line: 186
      },
      "13": {
        loc: {
          start: {
            line: 190,
            column: 23
          },
          end: {
            line: 190,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 190,
            column: 40
          },
          end: {
            line: 190,
            column: 47
          }
        }, {
          start: {
            line: 190,
            column: 50
          },
          end: {
            line: 190,
            column: 73
          }
        }],
        line: 190
      },
      "14": {
        loc: {
          start: {
            line: 217,
            column: 23
          },
          end: {
            line: 217,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 217,
            column: 35
          },
          end: {
            line: 217,
            column: 37
          }
        }],
        line: 217
      },
      "15": {
        loc: {
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 247,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 247,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 244
      },
      "16": {
        loc: {
          start: {
            line: 246,
            column: 13
          },
          end: {
            line: 246,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 246,
            column: 13
          },
          end: {
            line: 246,
            column: 36
          }
        }, {
          start: {
            line: 246,
            column: 40
          },
          end: {
            line: 246,
            column: 55
          }
        }],
        line: 246
      },
      "17": {
        loc: {
          start: {
            line: 256,
            column: 9
          },
          end: {
            line: 256,
            column: 73
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 256,
            column: 71
          },
          end: {
            line: 256,
            column: 73
          }
        }],
        line: 256
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0],
      "7": [0, 0],
      "8": [0, 0, 0, 0, 0],
      "9": [0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a1192052bb2f470c248dc4689b66833860f8c406"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2b1lomczov = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2b1lomczov();
/**
 * Enumeration for box shadow elements.
 * @enum {string}
 */
var BoxShadowElement = exports.BoxShadowElement = (cov_2b1lomczov().s[0]++, {
  Card: 'Card',
  Button: 'Button',
  Section: 'Section'
});
var SECTION_SHADOW_OPACITY = (cov_2b1lomczov().s[1]++, 0.05);
var COMMON_SHADOW_OPACITY = (cov_2b1lomczov().s[2]++, 0.1);
var BOX_SHADOW_DEFAULT_OPACITY = (cov_2b1lomczov().s[3]++, 0.48);
var BOX_SHADOW_DEFAULT_COLOR = (cov_2b1lomczov().s[4]++, '#8442d3');
var BOX_SHADOW_DEFAULT_STYLE = (cov_2b1lomczov().s[5]++, '0px 0px 0px 3px');
var BOX_SHADOW_STYLE_OF = (cov_2b1lomczov().s[6]++, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, BoxShadowElement.Card, '0 0 12px 0'), BoxShadowElement.Button, '0 0 6px 0'), BoxShadowElement.Section, '0 12px 24px 0'));
var BOX_SHADOW_OPACITY_OF = (cov_2b1lomczov().s[7]++, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, BoxShadowElement.Card, COMMON_SHADOW_OPACITY), BoxShadowElement.Button, COMMON_SHADOW_OPACITY), BoxShadowElement.Section, SECTION_SHADOW_OPACITY));

/**
 * Generates a CSS box-shadow style string with the given parameters.
 *
 * @param {string} [color=BOX_SHADOW_DEFAULT_COLOR] - The color of the box shadow. Defaults to `BOX_SHADOW_DEFAULT_COLOR`.
 * @param {string} [style=BOX_SHADOW_DEFAULT_STYLE] - The style of the box shadow (e.g., '0px 4px 6px'). Defaults to `BOX_SHADOW_DEFAULT_STYLE`.
 * @param {Object} [options={}] - Optional parameters.
 * @param {number} [options.colorOpacity=BOX_SHADOW_DEFAULT_OPACITY] - The opacity of the box shadow color. Defaults to `BOX_SHADOW_DEFAULT_OPACITY`.
 * @returns {string} A string containing the CSS custom property for box shadow color and the box-shadow style.
 *
 * @example
 * // Basic usage with default values
 * const shadowStyle = boxShadow();
 *
 * @example
 * // Custom color and style
 * const shadowStyle = boxShadow('red', '2px 2px 10px');
 *
 * @example
 * // Custom color, style, and opacity
 * const shadowStyle = boxShadow('blue', '0px 5px 15px', { colorOpacity: 0.5 });
 */
cov_2b1lomczov().s[8]++;
var boxShadow = exports.boxShadow = function boxShadow() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2b1lomczov().b[0][0]++, BOX_SHADOW_DEFAULT_COLOR);
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2b1lomczov().b[1][0]++, BOX_SHADOW_DEFAULT_STYLE);
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_2b1lomczov().b[2][0]++, {}),
    _ref3$colorOpacity = _ref3.colorOpacity,
    colorOpacity = _ref3$colorOpacity === void 0 ? (cov_2b1lomczov().b[3][0]++, BOX_SHADOW_DEFAULT_OPACITY) : _ref3$colorOpacity;
  cov_2b1lomczov().f[0]++;
  cov_2b1lomczov().s[9]++;
  return "\n  box-shadow: ".concat(style, " ").concat((0, _polished.rgba)(color, colorOpacity), ";\n");
};

/**
 * Generates a CSS size string with a unit.
 * If the input is a number, appends "px".
 * If the input is a string, returns it as-is.
 * If the input is neither a number nor a string, returns null.
 *
 * @param {number|string} value - The input value to convert to a CSS size.
 * @returns {string|null} The CSS size with a unit or null if the input is invalid.
 *
 * @example
 * getCssSize(20); // returns "20px"
 * getCssSize("15px"); // returns "15px"
 * getCssSize("2.5em"); // returns "2.5em"
 * getCssSize("50%"); // returns "50%"
 * getCssSize("30"); // returns "30"
 * getCssSize("100vw"); // returns "100vw"
 * getCssSize("3rem"); // returns "3rem"
 * getCssSize({}); // returns null
 */
cov_2b1lomczov().s[10]++;
var getCssSize = exports.getCssSize = function getCssSize(value) {
  cov_2b1lomczov().f[1]++;
  cov_2b1lomczov().s[11]++;
  if (typeof value === 'number') {
    cov_2b1lomczov().b[4][0]++;
    cov_2b1lomczov().s[12]++;
    return "".concat(value, "px");
  } else {
    cov_2b1lomczov().b[4][1]++;
  }
  cov_2b1lomczov().s[13]++;
  if (typeof value === 'string') {
    cov_2b1lomczov().b[5][0]++;
    cov_2b1lomczov().s[14]++;
    return value;
  } else {
    cov_2b1lomczov().b[5][1]++;
  }
  cov_2b1lomczov().s[15]++;
  return null; // or throw new Error('Invalid input');
};

/**
 * Extracts the individual padding values from a CSS padding string.
 * If padding values are not explicitly provided, it uses default values.
 *
 * @param {string} padding - The CSS padding string.
 * @param {string} [defaultValue='0'] - The default value for padding if not specified.
 * @returns {{ top: string, right: string, bottom: string, left: string }} - An object with individual padding values.
 *
 * @example
 * // With four values
 * getPadding("10px 20px 30px 40px"); // returns { top: "10px", right: "20px", bottom: "30px", left: "40px" }
 *
 * @example
 * // With two values
 * getPadding("10px 20px"); // returns { top: "10px", right: "20px", bottom: "10px", left: "20px" }
 *
 * @example
 * // With one value
 * getPadding("10px"); // returns { top: "10px", right: "10px", bottom: "10px", left: "10px" }
 *
 * @example
 * // With three values
 * getPadding("10px 20px 30px"); // returns { top: "10px", right: "20px", bottom: "30px", left: "20px" }
 *
 * @example
 * // With default value provided
 * getPadding("", "5px"); // returns { top: "5px", right: "5px", bottom: "5px", left: "5px" }
 *
 * @example
 * // With default value fallback
 * getPadding(""); // returns { top: "0px", right: "0px", bottom: "0px", left: "0px" }
 */
cov_2b1lomczov().s[16]++;
var getPadding = exports.getPadding = function getPadding(padding) {
  var _ref4;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2b1lomczov().b[6][0]++, '0px');
  cov_2b1lomczov().f[2]++;
  var parseValue = (cov_2b1lomczov().s[17]++, (_ref4 = (cov_2b1lomczov().b[7][0]++, padding)) !== null && _ref4 !== void 0 ? _ref4 : (cov_2b1lomczov().b[7][1]++, defaultValue));

  // Split the padding string into individual values
  var values = (cov_2b1lomczov().s[18]++, parseValue.split(' '));

  // Convert any shorthand values to full four-value format
  cov_2b1lomczov().s[19]++;
  switch (values.length) {
    case 1:
      cov_2b1lomczov().b[8][0]++;
      cov_2b1lomczov().s[20]++;
      values = [values[0], values[0], values[0], values[0]];
      cov_2b1lomczov().s[21]++;
      break;
    case 2:
      cov_2b1lomczov().b[8][1]++;
      cov_2b1lomczov().s[22]++;
      values = [values[0], values[1], values[0], values[1]];
      cov_2b1lomczov().s[23]++;
      break;
    case 3:
      cov_2b1lomczov().b[8][2]++;
      cov_2b1lomczov().s[24]++;
      values = [values[0], values[1], values[2], values[1]];
      cov_2b1lomczov().s[25]++;
      break;
    case 4:
      cov_2b1lomczov().b[8][3]++;
      cov_2b1lomczov().s[26]++;
      // Do nothing, values are already in the correct format
      break;
    default:
      cov_2b1lomczov().b[8][4]++;
      cov_2b1lomczov().s[27]++;
      return {
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px'
      };
  }
  cov_2b1lomczov().s[28]++;
  return {
    top: values[0],
    right: values[1],
    bottom: values[2],
    left: values[3]
  };
};

/**
 * Generates a box shadow style for the given element.
 *
 * @param {BoxShadowElement} element - The type of element to generate the box shadow for.
 * @returns {function(Object): string} A function that takes props and returns the box shadow CSS string.
 *
 * @example
 * // Usage with a Card element
 * const cardBoxShadow = boxShadowOf(BoxShadowElement.Card);
 * const cardProps = { theme: { shadowBaseColor: '#000000' } };
 * const cardShadowStyle = cardBoxShadow(cardProps);
 * // cardShadowStyle would be a string representing the box shadow CSS
 *
 * @example
 * // Usage with a Button element
 * const buttonBoxShadow = boxShadowOf(BoxShadowElement.Button);
 * const buttonProps = { theme: { shadowBaseColor: '#ff0000' } };
 * const buttonShadowStyle = buttonBoxShadow(buttonProps);
 * // buttonShadowStyle would be a string representing the box shadow CSS
 *
 * @example
 * // Usage with a Section element
 * const sectionBoxShadow = boxShadowOf(BoxShadowElement.Section);
 * const sectionProps = { theme: { shadowBaseColor: '#00ff00' } };
 * const sectionShadowStyle = sectionBoxShadow(sectionProps);
 * // sectionShadowStyle would be a string representing the box shadow CSS
 */
cov_2b1lomczov().s[29]++;
var boxShadowOf = exports.boxShadowOf = function boxShadowOf(element) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2b1lomczov().b[9][0]++, {}),
    defaultValue = _ref5.defaultValue;
  cov_2b1lomczov().f[3]++;
  cov_2b1lomczov().s[30]++;
  return function (props) {
    cov_2b1lomczov().f[4]++;
    var color = (cov_2b1lomczov().s[31]++, (0, _lodash.get)(props, 'theme.shadowBaseColor', defaultValue ? (cov_2b1lomczov().b[10][0]++, null) : (cov_2b1lomczov().b[10][1]++, '#212121')));
    var isValidElement = (cov_2b1lomczov().s[32]++, (0, _lodash.has)(BoxShadowElement, element));
    cov_2b1lomczov().s[33]++;
    if (((cov_2b1lomczov().b[12][0]++, !color) || (cov_2b1lomczov().b[12][1]++, !isValidElement)) && (cov_2b1lomczov().b[12][2]++, defaultValue)) {
      cov_2b1lomczov().b[11][0]++;
      cov_2b1lomczov().s[34]++;
      return defaultValue;
    } else {
      cov_2b1lomczov().b[11][1]++;
    }
    var validElement = (cov_2b1lomczov().s[35]++, isValidElement ? (cov_2b1lomczov().b[13][0]++, element) : (cov_2b1lomczov().b[13][1]++, BoxShadowElement.Button));
    cov_2b1lomczov().s[36]++;
    return boxShadow(color, BOX_SHADOW_STYLE_OF[validElement], {
      colorOpacity: BOX_SHADOW_OPACITY_OF[validElement]
    });
  };
};

/**
 * Generates CSS for border based on theme properties and light mode.
 *
 * @param {Object} options - Options for the border function.
 * @param {boolean} options.light - Determines if light mode is enabled.
 * @returns {function(Object): typeof import('styled-components').css} A function that takes props and returns the border CSS string.
 *
 * @example
 * // Usage with light mode
 * const lightBorder = border({ light: true });
 * const lightProps = { theme: { borderAndDividerWidth: '2px' }, borderAndDividerLightColor: '#FFFFFF' };
 * const lightBorderStyle = lightBorder(lightProps);
 * // lightBorderStyle would be a string representing the border CSS
 *
 * @example
 * // Usage with dark mode
 * const darkBorder = border({ light: false });
 * const darkProps = { theme: { borderAndDividerWidth: '2px', borderAndDividerColor: '#000000' } };
 * const darkBorderStyle = darkBorder(darkProps);
 * // darkBorderStyle would be a string representing the border CSS
 */
cov_2b1lomczov().s[37]++;
var border = exports.border = function border() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2b1lomczov().b[14][0]++, {}),
    light = _ref6.light;
  cov_2b1lomczov().f[5]++;
  cov_2b1lomczov().s[38]++;
  return function (props) {
    cov_2b1lomczov().f[6]++;
    cov_2b1lomczov().s[39]++;
    return (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  border: var(--dividerWidth, 1px) solid var(--dividerColor, #d5d5d9);\n"])));
  };
};

/**
 * Extracts the top and bottom box-shadow values from a box-shadow string.
 *
 * @param {string} boxShadow - The box-shadow string.
 * @returns {string} - A string containing only the top and bottom box-shadow values.
 *
 * @example
 * // With multiple shadows
 * extractTopBottomBoxShadow("0 5px 10px rgba(0, 0, 0, 0.5), 0 -5px 10px rgba(0, 0, 0, 0.5), 10px 10px 20px rgba(0, 0, 0, 0.2)");
 * // returns "0 5px 10px rgba(0, 0, 0, 0.5), 0 -5px 10px rgba(0, 0, 0, 0.5)"
 *
 * @example
 * // With no matching shadows
 * extractTopBottomBoxShadow("10px 10px 20px rgba(0, 0, 0, 0.2)");
 * // returns ""
 */
cov_2b1lomczov().s[40]++;
var extractTopBottomBoxShadow = exports.extractTopBottomBoxShadow = function extractTopBottomBoxShadow(boxShadowString) {
  cov_2b1lomczov().f[7]++;
  // Split the box-shadow string into individual shadows
  var shadows = (cov_2b1lomczov().s[41]++, boxShadowString.split(','));

  // Filter the shadows to include only those with vertical offsets
  var topBottomShadows = (cov_2b1lomczov().s[42]++, shadows.filter(function (shadow) {
    cov_2b1lomczov().f[8]++;
    var parts = (cov_2b1lomczov().s[43]++, shadow.trim().split(/\s+/));
    cov_2b1lomczov().s[44]++;
    if (parts.length >= 2) {
      cov_2b1lomczov().b[15][0]++;
      var offsetY = (cov_2b1lomczov().s[45]++, parts[1]);
      cov_2b1lomczov().s[46]++;
      return (cov_2b1lomczov().b[16][0]++, offsetY.startsWith('-')) || (cov_2b1lomczov().b[16][1]++, offsetY !== '0');
    } else {
      cov_2b1lomczov().b[15][1]++;
    }
    cov_2b1lomczov().s[47]++;
    return false;
  }));

  // Join the filtered shadows back into a string
  cov_2b1lomczov().s[48]++;
  return topBottomShadows.join(', ');
};
cov_2b1lomczov().s[49]++;
var inputMixin = exports.inputMixin = function inputMixin(_ref7) {
  var _ref7$theme = _ref7.theme,
    _ref7$theme2 = _ref7$theme === void 0 ? (cov_2b1lomczov().b[17][0]++, {}) : _ref7$theme,
    generalBorderRadius = _ref7$theme2.generalBorderRadius,
    inputAndButtonHeight = _ref7$theme2.inputAndButtonHeight,
    primaryColor = _ref7$theme2.primaryColor;
  cov_2b1lomczov().f[9]++;
  cov_2b1lomczov().s[50]++;
  return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  ", ";\n  border-radius: var(--generalBorderRadius, 12px);\n  padding: 0 ", "px;\n  height: var(--inputButtonHeight, 40px);\n  background-color: ", ";\n\n  :active,\n  :focus,\n  :focus-within,\n  :focus-visible {\n    ", ";\n  }\n"])), border(), _themeMapper.evolutionTheme.spacings.lg, function (props) {
    cov_2b1lomczov().f[10]++;
    cov_2b1lomczov().s[51]++;
    return (0, _lodash.get)(props, 'theme.contentBgColor', '#ffffff');
  }, boxShadow(primaryColor));
};